import { forwardRef } from 'react';

import { StyledResultTextarea } from './ResultBox.styled';

type ResultBoxProps = {
   value: string;
   onChange: (value: string) => void;
};

/**
 * ResultBox — editable textarea for accumulated transcription result.
 * Exposes a ref so the parent can read selectionStart/selectionEnd
 * for partial (selection-based) redaction.
 */
export const ResultBox = forwardRef<HTMLTextAreaElement, ResultBoxProps>((props, ref) => {
   return (
      <StyledResultTextarea
         ref={ref}
         value={props.value}
         onChange={(event) => props.onChange(event.target.value)}
         spellCheck={false}
      />
   );
});

ResultBox.displayName = 'ResultBox';
